import   React                   ,
       { useEffect               ,
	     useState                }  from "react";

import   classNames                 from 'classnames';
		 
import   styles                     from './ProductList.module.scss';

import   Field                      from '../../widget/inputs/Field';
import   Select                     from '../../widget/inputs/Select';
import   AnimatedWaitingIcon2        from '../../widget/animations/animatedWaitingIcon2';
import   Trigger                    from '../../widget/actuators/Trigger';
import   ColumnTitle                from '../../widget/dataDisplay/labels/ColumnTitle'
import   Window                     from '../../widget/windows/window';
import   ProductRow                 from './ProductRow';
import   ProductSheet               from './ProductSheet';
import   ProductCategoryManager     from '../productCategoryManagment/ProductCategoryManager';

import { Product                 ,
         ProductCategory         }  from '../../../dataTypes/productManagment/types';
import { getProducts             ,
         deleteProduct           ,
         updateProductVisibility }  from '../../../backendServices/productManagment/api_product';
import { getProductCategories    }  from '../../../backendServices/productManagment/api_productCategory';

import { useTypedSelector                  }  from '../../../store/useTypeSelector';
import { RootState                         }  from '../../../store/generalReducer';

export interface ProductListProps {
  productType?: string;
}

export const ProductList = ({ productType }: ProductListProps) => {

  const productTypeNames = ['Tous', 'Produit physique', 'Abonnement', 'Vidéo payante', 'Chaîne payante' , 'Masterclass Urban Tour', 'Quota créateur'];

  const productTypeMapping: { [key: string]: string } = {
    'Tous'                   : 'All',
    'Produit physique'       : 'Physical Item',
    'Abonnement'             : 'Subscription',
    'Vidéo payante'          : 'PayVideo',
    'Chaîne payante'         : 'PayChannel',
	'Masterclass Urban Tour' : 'Urban Tour Masterclass',
	'Quota créateur'         : 'CreatorCapacity'
  };

  const { authentication } = useTypedSelector((state: RootState) => state.authenticationReducer);

  const [ categorySet           , setCategorySet           ] = useState<ProductCategory[]>([]);
  const [ productSet            , setProductSet            ] = useState<Product[]>([]);
  const [ productSet2           , setProductSet2           ] = useState<Product[]>([]);

  const [ showWaitingIcon       , setShowWaitingIcon       ] = useState(false);

  const [ selectedProductType      , setSelectedProductType      ] = useState('Tous');
  const [  , setSelectedProductTypeIndex ] = useState(0);
  const [ selectedCategory      , setSelectedCategory      ] = useState('Toutes');
  const [ selectedCategoryIndex , setSelectedCategoryIndex ] = useState(0);
  const [ filter                , setFilter                ] = useState('');

  const [          , setEditProductId         ] = useState<number | null>(null);
  const [ editProductIndex      , setEditProductIndex      ] = useState<number | null>(null);
  const [ createNewProduct      , setCreateNewProduct      ] = useState<boolean>(false);
  const [ showCategoryManager   , setShowCategoryManager   ] = useState<boolean>(false);

  const [ showMessageWindow     , setShowMessageWindow     ] = useState ( false );
  const [ message               , setMessage               ] = useState ( <></> );

  const [ showConfirmation      , setShowConfirmation      ] = useState (false);
  const [ productToDelete       , setProductToDelete       ] = useState<Product | null>(null);

  useEffect(() => {
  
  
    const fetchData = async () => {
	
      try 
	   {
        setShowWaitingIcon(true);

        const [productsResult, categoriesResult] = await Promise.all([
          getProducts(productType, authentication.admin?.id),
          getProductCategories(authentication.admin?.id),
        ]);

        console.log (productsResult)

        if (productsResult.payload) 
		 {
          setProductSet  (productsResult.payload);
          setProductSet2 (productsResult.payload); 
         }

        if (categoriesResult.payload) 
		 {
          setCategorySet ( categoriesResult.payload.sort((a, b) => a.rank - b.rank) );
         }
       } 
	  catch (error) 
	   {
        console.error('Error fetching data:', error);
       } 
	  finally 
	   {
        setShowWaitingIcon(false);
       }
    };

    fetchData();
  }, []);


  const reinit = async () => {

    setShowWaitingIcon(true);

    const productsResult  = await getProducts(productType, authentication.admin?.id)

    if (productsResult.payload)
	 {
      setProductSet2 (productsResult.payload);
      // Les filtres restent affichés : la liste doit continuer à en tenir compte.
      setProductSet  (filterProducts(selectedCategoryIndex, filter, selectedProductType, productsResult.payload));
     }

    setShowWaitingIcon(false);
  }

  const checkFilter = (subChaine: string, chaine: string) => {
    if (subChaine === '') return true;
    return chaine.toUpperCase().includes(subChaine.toUpperCase());
  };

  const filterProducts = (categoryIndex: number, filterText: string, productType: string, source: Product[] = productSet2): Product[] => {
    return source.filter((product) => {
      const matchesCategory = categoryIndex <= 1 || product.categoriesIds.includes(categorySet[categoryIndex - 2]?.id);
      const matchesFilter = checkFilter(filterText, product.name);
      const matchesProductType = productType === 'Tous' || product.kind === productTypeMapping[productType];
      return matchesProductType && matchesCategory && matchesFilter;
    });
  };

  const handleProductTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newProductType = e.target.value;
    setSelectedProductType(newProductType);
    setSelectedProductTypeIndex(e.target.selectedIndex);
    setProductSet(filterProducts(selectedCategoryIndex, filter, newProductType));
  };

  const handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newCategoryIndex = e.target.selectedIndex;
    setSelectedCategory(e.target.value);
    setSelectedCategoryIndex(newCategoryIndex);
    setProductSet(filterProducts(newCategoryIndex, filter, selectedProductType));
  };

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFilter = e.target.value;
    setFilter(newFilter);
    setProductSet(filterProducts(selectedCategoryIndex, newFilter, selectedProductType));
  };


  const handleEditionClick = (index: number) => {
    setEditProductId(productSet[index].id); // Passer en mode carousel avec l'ID de la vidéo
    setEditProductIndex(index); // Passer en mode carousel avec l'ID de la vidéo
  };


  const handleDeleteClick = (product: Product) => {

    setProductToDelete(product);
    setShowConfirmation(true);
  };

  const handleDeleteConfirmation = async (confirmed: boolean)=> {

    if ( confirmed && productToDelete )
     {
      try
       {
        const response = await deleteProduct (productToDelete.id);

        if (response.code === 1)
              {
               setProductSet((prev) => prev.filter((product) => product.id !== productToDelete.id));
               setProductSet2((prev) => prev.filter((product) => product.id !== productToDelete.id));
               setMessage(<></>);
               setShowMessageWindow(false);	   
              }
         else {
               console.warn(`Impossible de supprimer le produit ID ${productToDelete.id} : ${response.comment}`);
               setMessage (
                           response.code === -103
                           ? <>Impossible de supprimer le produit car il est déjà lié à d'autres ressources</>
                           : <>Impossible de supprimer le produit</>
                          );
               setShowMessageWindow(true);
              }
       }
      catch (error)
       {
        console.error(`Erreur lors de la suppression du produit ID ${productToDelete.id}:`, error);
        setMessage(<>Impossible de supprimer le produit</>);
        setShowMessageWindow(true);
       }

     }

    setShowConfirmation(false);
    setProductToDelete(null);
  };

  const handleVisibilityChange = (productId: number) => {

    setProductSet((prevProductSet) => {

      const updatedProductSet = prevProductSet.map((product) => {

        if (product.id === productId )
         {
          const newState = !(product.active); // Inverser l'état
          updateProductVisibility(product.id, newState); // Appeler l'API
          return { ...product, active: newState }; // Retourner le média mis à jour
         }

        return product;
       });

    // productSet2 est la liste complète : on n'y reporte que les produits modifiés,
    // sans l'écraser par la liste filtrée.
    setProductSet2((prev) => prev.map((p) => updatedProductSet.find((u) => u.id === p.id) ?? p));

    return updatedProductSet;
   });
  };

  const handleNewProductCreationClick = () => {
    setCreateNewProduct (true)
  };
  
  const renderProductTypeSelection = (): JSX.Element => {

    return (
      <Select choices  = {productTypeNames}
              value    = {selectedProductType}
              onChange = {handleProductTypeChange}
              height   = "26px" />
    );
  };


  const renderCategoriesSelection = (): JSX.Element => {
    const categoriesNames = ['Toutes', ...categorySet.map((c) => c.name)];
    return (
      <Select choices  = {categoriesNames}
              value    = {selectedCategory}
              onChange = {handleCategoryChange}
              height   = "26px" />
    );
  };

  const handleProductCreate = ( id: number ) => {

    setCreateNewProduct (false)
    reinit ()
  }

  const handleProductEdit = ( id: number ) => {

    setCreateNewProduct (false)
    setEditProductId    (null);
    setEditProductIndex (null);
    reinit ()
  }

  // Retour à la liste des produits : les catégories ont pu être créées / supprimées / réordonnées,
  // et le filtre catégorie est indexé sur la position dans categorySet — on le remet à zéro.
  const handleCategoryManagerClose = async () => {

    setShowCategoryManager   (false);
    setSelectedCategory      ('Toutes');
    setSelectedCategoryIndex (0);
    setProductSet            (filterProducts(0, filter, selectedProductType));

    try
     {
      const categoriesResult = await getProductCategories(authentication.admin?.id);

      if (categoriesResult.payload)
       {
        setCategorySet ( categoriesResult.payload.sort((a, b) => a.rank - b.rank) );
       }
     }
    catch (error)
     {
      console.error('Error fetching categories:', error);
     }
  };

  const renderComponent = () : JSX.Element => {

           if ( showCategoryManager )
                 {
                  return <ProductCategoryManager onBackToProducts={handleCategoryManagerClose} />
                 }

           if ( createNewProduct )
                 {
                  return <ProductSheet onCreate    = {handleProductCreate} />
                 }
            else {
                  if ( editProductIndex !== null )
                        {
                         return <ProductSheet product     = {productSet[editProductIndex]} 
						                      onEdit      = {handleProductEdit} 
											  productKind={productSet[editProductIndex].kind ?? undefined} />
                        }
                   else {
                         return (
                                  <>

                                    <div className={classNames(styles.upper_bar)}>

                                        {renderProductTypeSelection()}
                                        {renderCategoriesSelection()}

                                        <Field type        = "text"
                                               placeholder = "Rechercher..."
                                               value       = {filter}
                                               onChange    = {handleFilterChange} />

                                      <div className={classNames(styles.productCreationButton)}>
                                        <Trigger name    = {"Catégories produits"}
                                                 onClick = {() => setShowCategoryManager(true)}
                                                 variant = "tailwind2"  />
                                      </div>

                                      <div className={classNames(styles.productCreationButton)}>
                                        <Trigger name    = {"Créer un produit"}
                                                 onClick = {handleNewProductCreationClick}
                                                 variant = "tailwind2"  />
                                      </div>
									  
                                    </div>

                                    <div className={classNames(styles.list_container)}>

                                      <div className={classNames(styles.list)}>
                                        <ColumnTitle titles = {[ 'Type' , 'Vignette' , 'Nom'  , 'Catégorie' , 'URL'   , 'Prix HT' , 'Prix TTC' , 'Action' ,'Actif' , 'Public' ]}
                                                     widths = {[ '50px' , '150px'    , 'auto' , '300px'     , '350px' , '100px'   , '100px'    , '80px'   , '80px' , '80px'   ]} />

                                        {
                                         productSet.map ( (product, index) => (
                                                                                <ProductRow key                = {product.id}
                                                                                            product            = {product}
																							productCategories  = {categorySet}
                                                                                            index              = {index}
                                                                                            onEdit             = {handleEditionClick}
                                                                                            onDelete           = {handleDeleteClick}
                                                                                            onVisibilityToggle = {handleVisibilityChange} />
                                                                              )
                                                        )
                                        }
                                      </div>

                                    </div>

                                  </>
                                )
                        }
                 }
  }

  const handleMessageWindowClose = () => {

    setShowMessageWindow (false)
  }




  return (
    <div className={classNames(styles.root)}>

      {
        showWaitingIcon && <AnimatedWaitingIcon2 />
      }

      {
        showMessageWindow &&
        <Window message                 = {message}
                messageType             = "information"
                onClickOnValidateButton = {handleMessageWindowClose} 
				validButtonText="Ok"    />
      }

      {
        showConfirmation &&
        <Window message                 = {<>{`Êtes-vous sûr de vouloir supprimer le produit ${productToDelete?.name} ?`}</>}
                messageType             = "question"
                onClickOnValidateButton = {() => handleDeleteConfirmation(true)}
                onClickOnCancelButton   = {() => handleDeleteConfirmation(false)} 
		  validButtonText="Oui"
		  cancelButtonText="Non" />
      }

      {renderComponent ()}
    </div>
  );
};

export default ProductList;
